import React, { useContext, useEffect, useState } from "react"
import Context from "../utils/Context"
import { cancelActions, sendJourney, sendTaskToRobot } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStopCircle } from "@fortawesome/free-solid-svg-icons"
import api from "../api/api"

export default function ModalUnoccupy() {
    const context = useContext(Context)

    const [racks, setRacks] = useState([])
    const [position, setPosition] = useState({ point: '', height: '' })
    const [vacatingFlag, setVacatingFlag] = useState(false)
    const [returnFlag, setReturnFlag] = useState(false)
    const [returningFlag, setReturningFlag] = useState(false)

    useEffect(() => {
        api.fetchRacks()
            .then((res) => {
                res && setRacks(res.data)
            })
    }, [])

    useEffect(() => {
        if (context.endOfMission && vacatingFlag) {
            if (!returnFlag) setReturnFlag(true)
            else {
                setReturnFlag(false)
                setReturningFlag(false)
                setVacatingFlag(false)
            }
        }
    }, [context.endOfMission])

    // start task
    const startTask = (mission) => {
        if (mission) {
            sendTaskToRobot({ actions: mission.actions, id: mission.name, name: mission.name })
            context.actions.setMessage({ message: "Missão iniciada!", type: "success" })
            console.log('publicando missão: ', { actions: mission.actions, id: mission.name, name: mission.name })
        }
    }

    const unoccupyPosition = () => {
        const [point, height] = document.getElementById('unoccupy-select').value.split('-')
        setPosition({ point: point, height: height })

        var unoccupyTask = {
            "name": "Clear " + document.getElementById('unoccupy-select').value,
            "actions": [
                //PICK
                {
                    "id": "go-to",
                    "name": "go-to",
                    "needsValue": true,
                    "value": "A" + point
                },
                {
                    "id": "orientate-to-fork",
                    "name": "orientate-to-fork",
                    "needsValue": true,
                    "value": point
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": height
                },
                {
                    "id": "orientate-to-fork",
                    "name": "orientate-to-fork",
                    "needsValue": true,
                    "value": point
                },
                {
                    "id": "move",
                    "name": "move",
                    "needsValue": true,
                    "value": "-1.4"
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": (parseFloat(height) + parseFloat(context.forkDiff)).toString()
                },
                {
                    "id": "undock-pallet",
                    "name": "undock-pallet",
                    "needsValue": false
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": "0.15"
                },
                //DROP
                {
                    "id": "go-to",
                    "name": "go-to",
                    "needsValue": true,
                    "value": "A" + point.slice(0, 8) + "1"
                },
                {
                    "id": "orientate-to",
                    "name": "orientate-to",
                    "needsValue": true,
                    "value": "A" + point.slice(0, 8) + "2"
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": '0.0'
                },
                {
                    "id": "undock-pallet",
                    "name": "undock-pallet",
                    "needsValue": false
                }
            ]
        }

        if (!context.zoneStatus.name.some(zone => zone === point.slice(2, 7))) {
            let prePoint = [
                {
                    "id": "go-to",
                    "name": "go-to",
                    "needsValue": true,
                    "value": "A_" + point.slice(2, 7)
                },
                {
                    "id": "orientate-to",
                    "name": "orientate-to",
                    "needsValue": true,
                    "value": "A" + point
                }
            ]

            unoccupyTask.actions = prePoint.concat(unoccupyTask.actions)
        }

        setVacatingFlag(true)
        context.actions.setLastDrop({ point: "A" + point.slice(0, 8) + "1", height: '0.0' })
        localStorage.setItem("lastDrop", JSON.stringify({ point: "A" + point.slice(0, 8) + "1", height: '0.0' }))
        startTask(unoccupyTask)
    }

    const returnPallet = () => {
        var returnTask = {
            "name": "Return " + position.point + "-" + position.height,
            "actions": [
                //PICK
                {
                    "id": "orientate-to-fork",
                    "name": "orientate-to-fork",
                    "needsValue": true,
                    "value": "A" + position.point.slice(0, 8) + "1"
                },
                {
                    "id": "move",
                    "name": "move",
                    "needsValue": true,
                    "value": "-1.4"
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": "0.15"
                },
                //DROP
                {
                    "id": "go-to",
                    "name": "go-to",
                    "needsValue": true,
                    "value": "A" + position.point
                },
                {
                    "id": "orientate-to-fork",
                    "name": "orientate-to-fork",
                    "needsValue": true,
                    "value": position.point
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": (parseFloat(position.height) + parseFloat(context.forkDiff)).toString()
                },
                {
                    "id": "orientate-to-fork",
                    "name": "orientate-to-fork",
                    "needsValue": true,
                    "value": position.point
                },
                {
                    "id": "move",
                    "name": "move",
                    "needsValue": true,
                    "value": "-1.4"
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": position.height
                },
                {
                    "id": "undock-pallet",
                    "name": "undock-pallet",
                    "needsValue": false
                },
                {
                    "id": "fork",
                    "name": "fork",
                    "needsValue": true,
                    "value": "0.0"
                }
            ]
        }

        setReturningFlag(true)
        context.actions.setLastDrop({ ...position })
        localStorage.setItem("lastDrop", JSON.stringify({ ...position }))
        startTask(returnTask)
    }

    return (
        <div className="modal is-active">
            <div className="modal-background"></div>

            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <header className="modal-card-head">
                    <p className="modal-card-title">Clear Position</p>
                    {!vacatingFlag &&
                        <button
                            className="delete"
                            aria-label="close"
                            onClick={() => context.actions.setModalState({ ...context.modalState, unoccupy: false })}
                        ></button>
                    }
                </header>

                <section className="modal-card-body">
                    <div className="field mb-5">
                        <div className="controls">
                            <div className="control mb-3">
                                <p>
                                    {!vacatingFlag && 'The chosen position will be cleared temporarily.'}
                                    {vacatingFlag && !returnFlag && 'Clearing position. Please wait.'}
                                    {returnFlag && !returningFlag && 'The position is cleared. Do you wish to return the pallet?'}
                                    {returningFlag && 'Return pallet. Please wait.'}
                                </p>
                            </div>
                            {!vacatingFlag &&
                                <div className="control mb-3">
                                    <p>
                                        <div class='control' style={{ display: 'inline' }}>
                                            <select id='unoccupy-select'>
                                                <option value='' selected disabled style={{ textAlign: 'left' }}>Position...</option>
                                                {racks &&
                                                    racks.map((r) => {
                                                        if (r.occupation === 'true' && r.rack !== 'P') return <option value={r.pointName + '-' + r.forkHeight} style={{ textAlign: 'left' }}>{r.rack}.{r.position}</option>
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </p>
                                </div>
                            }
                        </div>
                    </div>
                </section>

                <footer className="modal-card-foot">
                    {document.getElementById('unoccupy-select')?.value !== '' && !vacatingFlag &&
                        <button className="button is-success" onClick={unoccupyPosition}>
                            Clear
                        </button>
                    }

                    {returnFlag && !returningFlag &&
                        <button className="button is-success outlined" onClick={returnPallet}>
                            Return
                        </button>
                    }

                    {!vacatingFlag &&
                        <button className="button is-link" onClick={() => context.actions.setModalState({ ...context.modalState, unoccupy: false })}>
                            Close
                        </button>
                    }
                </footer>
            </div>
        </div>
    )
}